/* eslint-disable no-empty */
/* eslint-disable no-underscore-dangle */
/**
 * Main application forms
 */
import "./style.css";
import MDBox from "components/Basics/MDBox";
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartsActions from "redux-react/actions/chartsActions";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Icon,
	IconButton,
	Menu,
	MenuItem,
	Tooltip
} from "@mui/material";
import i18n from "i18n";
import lod_ from "lodash";
import { useMaterialUIController } from "context";
import ChartsLoader from "components/Custom/ChartsLoader";
import DefaultDataTable from "components/Custom/Tables/DefaultDataTable";
import MDButton from "components/Basics/MDButton";
import { read, utils } from "xlsx";
import { getLocalStorageBackValues } from "components/Custom/Filters/filters";
import FormDictionaryDialog from "components/Custom/FormDictionary";
import { socket } from "redux-react/middleware/ws";
import MDTypography from "components/Basics/MDTypography";
import useFilters from "hooks/useFilters";
import ImportDialog from "./import";
import ActionFusionContact from "./components/ActionFusionContact";
import ResourceEventsMenu, { ALLOWED_ACTION_TYPE } from "./components/ResourceEventsMenu";
import { useUrlQuery } from "hooks/useUrlQuery";

// Actions
import ActionsController from "./actions";
import { useResourceActions } from "hooks/useResourceActions";
import { useAppActions } from "hooks/useAppActions";
import { useFormActions } from "hooks/useFormActions";
import { createDictionarySkeleton } from "helpers/form";
import { t } from "i18next";
import InterfaceController, { INTERFACE_ACTION } from "./interface";
import { display } from "redux-react/reducers/snackBarReducer";

/**
 *
 * @param {Object} route
 *  - key : actual page
 *  - type : type of page
 *  - icon : icon to display in navbar
 *  - route : actual route
 * @returns
 */
export default function FormsPage({ route }) {
	/** URL Query params */
	const getUrlQuery = useUrlQuery();
	const [filtersURL, setFiltersURL] = useState(getUrlQuery());
	/**  */

	const dispatch = useDispatch();

	const [addNewItem, setAddNewItem] = useState(false);
	const [valuesForm, setValuesForm] = useState({});
	const [formBuild, setFormBuild] = useState({});
	const [contextDictionary, setContextDictionary] = useState({});
	const [PI, setPI] = useState(false);
	const [empty, setEmpty] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);

	const { profile, filters } = useSelector(state => state);
	const [controller] = useMaterialUIController();
	const { darkMode } = controller;
	// Loader while charts are loading
	const [chartsLoading, setChartsLoading] = useState(false);
	// Page Charts
	const [charts, setCharts] = useState([]);
	// Filters configuration for the page
	const [pageFilters, setPageFilters] = useState([]);
	const [listAPIs, setlistAPIs] = useState([]);
	const [selectedItem, setSelectedItem] = useState({});
	const [selectedTarget, setSelectedTarget] = useState("");
	const [routeDict, setRouteDict] = useState("");
	const [flagAccount, setFlagAccount] = useState(false);
	const [regexEmail, setRegexEmail] = useState("");
	const [selectedId, setSelectedId] = useState(null);
	const [reloadTable, setReloadTable] = useState(false);
	// Datas for dialog
	const [importDialog, setImportDialog] = useState({ open: false });
	// File name when import CSV
	const [fileImportName, setFileImportName] = useState("");

	const [menuRef, setMenuRef] = useState(null);
	const [menuValues, setMenuValues] = useState({});

	// Dictionary for dialog
	const [dictionary, setDictionary] = useState({});

	// Resource controller
	const [resource, setResource] = useState(null);

	const [selectedRows, setSelectedRows] = useState([]);

	const actionControllerRef = useRef();
	const interfaceControllerRef = useRef();

	// Form API
	const {
		getItemsFromCollection,
		getItemByID,
		getItemEmpty,
		deleteItem,
		addItem,
		updateItem,
		importCSV
	} = useFormActions();
	// Resource API
	const { insertResource, updateResource, deleteResource, performAction, insertResourceEvent } =
		useResourceActions();
	// App action
	const { showSuccessMessage, showErrorMessage, showInfoMessage } = useAppActions();
	// Generate filters components
	const filtersComponents = useFilters(route.route, pageFilters);

	/**
	 * Get charts data to be displayed in front
	 */
	function getChartsData(typeList) {
		return charts;
	}
	/**
	 * Get charts with filters from the back
	 */
	async function getCharts(requestFilters, pageFilters) {
		let mandatoryFilters = pageFilters.map(filter => filter.attribute);

		return new Promise((resolve, reject) => {
			dispatch(
				ChartsActions.getPageCharts(
					profile.assistantID,
					route,
					{ ...requestFilters, ...filtersURL },
					mandatoryFilters,
					res => resolve(res.charts)
				)
			);
		});
	}
	/**
	 * Get filters from back
	 */
	async function getPageFilters() {
		if (route.filter) {
			// If route has filter, get it
			return new Promise((resolve, reject) => {
				dispatch(
					ChartsActions.getPageFilters(profile.assistantID, route.filter, res => {
						resolve(res.filters);
					})
				);
			});
		} else {
			// return empty array
			return [];
		}
	}

	const actionEditHandle = (items, target, account) => {
		const onSuccess = res => {
			setAddNewItem(true);
			setEmpty(false);
			setValuesForm(res.valueDictionary);
			setlistAPIs(res.APIs);
			setFormBuild(res.formBuilderDictionary);
			setContextDictionary(res.dictionary);
			setPI(false);
			setSelectedId(items._id);
			setRegexEmail(res.regexEmail);
			setSelectedTarget(target);
			setRouteDict(route.form.routeDictionary);
			setFlagAccount(account);
		};

		const customInterface = resource?.format?.display;

		if (!lod_.isNil(customInterface)) {
			interfaceControllerRef.current?.display(customInterface, {
				action: INTERFACE_ACTION.UPDATE,
				payload: {
					edit: true,
					_id: items._id
				}
			});
		} else {
			getItemByID(items._id, target, route.form.routeDictionary, onSuccess, false, account);
		}
	};

	const actionEditEmptyHandle = () => {
		const onSuccess = res => {
			// Create an empty form based on the dictionary
			const emptyForm = createDictionarySkeleton(res.dictionary, {});

			setAddNewItem(true);
			setEmpty(true);
			setValuesForm(emptyForm);
			setlistAPIs(res.APIs);
			setRegexEmail(res.regexEmail);
			setFormBuild(res.formBuilderDictionary);
			setContextDictionary(res.dictionary);
			setPI(true);
			setSelectedTarget(route.form.collectionDefault);
			setRouteDict(route.form.routeDictionary);
		};

		const customInterface = resource?.format?.display;

		if (!lod_.isNil(customInterface)) {
			interfaceControllerRef.current?.display(customInterface, {
				action: INTERFACE_ACTION.INSERT,
				payload: {
					test: "hello"
				}
			});
		} else {
			getItemEmpty(route.form.collectionDefault, route.form.routeDictionary, onSuccess);
		}
	};

	/**
	 * Load charts from back
	 */
	const loadCharts = async (urlQuery = {}) => {
		// Get all filters from back
		let pageFilters = await getPageFilters();
		setPageFilters(pageFilters);
		// Get filters from local storage
		let actualFilters = getLocalStorageBackValues(
			profile.selectedAssistant.assistantID,
			route.route,
			filters
		);
		// Build charts with filters
		let chartsFromDatabase = await getCharts(actualFilters, pageFilters);
		setCharts(chartsFromDatabase);

		const list = chartsFromDatabase[0];
		if (!lod_.isNil(list)) {
			setDictionary(list.dictionary);
			setResource(list.resource);
			if (!lod_.isEmpty(list.resource?.frontFilters) && !lod_.isNil(list.resource?.frontFilters)) {
				setPageFilters(list.resource.frontFilters);
			}

			// If we have an ID in the URL, we open the item editor
			if (!lod_.isNil(urlQuery._id)) {
				actionEditHandle(
					{
						_id: urlQuery._id
					},
					list.request.collection
				);
			}
		}

		setChartsLoading(false);
	};

	const actionDeleteHandle = (item, target) => {
		setConfirmDelete(true);
		setSelectedItem(item);
		setSelectedTarget(target);
	};

	const closeDeleteHandle = () => {
		setConfirmDelete(false);
	};

	const deleteItemHandle = () => {
		const onSuccess = res => {
			showSuccessMessage(i18n.t("FORMS.deleteSuccess"));
			setReloadTable(!reloadTable);
			setConfirmDelete(false);
		};

		let actions = charts[0].actions || [];

		actions = actions.filter(action => action.CRUD.includes("delete"));
		actions = actions.map(action => action.action);

		if (lod_.isEmpty(resource) && lod_.isEmpty(actions)) {
			// Form API way
			if (selectedItem._id) {
				deleteItem(
					selectedItem._id,
					selectedTarget,
					{
						actions
					},
					onSuccess
				);
			} else {
				setConfirmDelete(false);
				showErrorMessage(i18n.t("FORMS.deleteError"));
			}
		} else {
			// Resource API way
			deleteResource(resource.code, selectedItem._id, onSuccess, () => {
				showErrorMessage(i18n.t("FORMS.deleteError"));
			});
		}
	};

	const addItemHandle = (values, unique, callback, rolesProfileUser) => {
		const onSuccess = res => {
			showSuccessMessage(i18n.t("FORMS.addEmpty"));
			setReloadTable(!reloadTable);
			setAddNewItem(false);
			callback(true);
		};

		let actions = charts[0].actions || [];
		actions = actions.filter(action => action.CRUD.includes("insert"));
		actions = actions.map(action => action.action);

		if (lod_.isEmpty(resource) && lod_.isEmpty(actions)) {
			/**
			 * Add item with form API (old way)
			 */
			const data = { values, target: selectedTarget, unique, actions, rolesProfileUser };

			addItem(data, onSuccess, () => callback(false));
		} else {
			/**
			 * Add item with resource API
			 */
			insertResource(resource.code, values, onSuccess, () => {
				showErrorMessage(i18n.t("FORMS.addError"));
			});
		}
	};

	const updateItemHandle = (values, unique, callback) => {
		const onSuccess = res => {
			showSuccessMessage(i18n.t("FORMS.addEmpty"));
			setReloadTable(!reloadTable);
			setAddNewItem(false);
			callback(true);
		};

		let actions = charts[0].actions || [];
		actions = actions.filter(action => action.CRUD.includes("update"));
		actions = actions.map(action => action.action);

		if (lod_.isEmpty(resource) && lod_.isEmpty(actions)) {
			/**
			 * Update item with form API (old way)
			 */
			let data = { values, target: selectedTarget, unique, actions };

			updateItem(selectedId, data, onSuccess, err => {
				callback(false);
			});
		} else {
			/**
			 * Update item with resource API
			 */
			updateResource(resource.code, selectedId, values, onSuccess);
		}
	};
	// Handle import CSV
	const handleImportFile = event => {
		try {
			let file = event.target.files[0];
			const reader = new FileReader();

			reader.onload = e => {
				const wb = read(e.target.result, { type: "binary", codepage: 65001 });
				const sheets = wb.SheetNames;
				const sheet = wb.Sheets[sheets[0]];

				// Get header column names from the first row (before converting to JSON)
				const headers = utils.sheet_to_json(sheet, { header: 1 })[0] || [];

				// Get the data
				const data = utils.sheet_to_json(sheet);
				// Open import modal with data
				setImportDialog({ ...importDialog, open: true, values: data, headers });
			};
			reader.readAsArrayBuffer(file);
			// Set file name
			setFileImportName(file.name);
			// Reset input
			event.target.value = null;
		} catch (error) {}
	};
	// Import CSV datas in DB
	const handleImportCSV = obj => {
		// Add supplementary datas
		obj.collection = route.form.collectionDefault;
		obj.assistantID = profile.assistantID;
		obj.fileName = fileImportName;

		const onSuccess = res => {
			showSuccessMessage(`${res.insertedCount} données importées`);
			setReloadTable(!reloadTable);
		};

		importCSV(obj, onSuccess);
	};

	/**
	 * Perform action on resource
	 * @param {object} event - Event to perform
	 * @param {array} values - Values to perform action on
	 */
	const performActionHandle = async (event, values = []) => {
		switch (event.type) {
			case "actionFront": {
				const ids = values.map(v => v._id);

				const items = await getItemsFromCollection(resource.storage.collection, {
					query: {
						_id: { $in: ids }
					}
				});

				actionControllerRef.current?.performFrontAction(event, items, resource, result => {
					if (result.success) {
						loadCharts();
					} else {
						dispatch(
							display({
								message: t("FORMS.RESOURCE.actionError"),
								type: "error"
							})
						);
					}
				});
				break;
			}
			default: {
				performAction(
					{
						resourceCode: resource.code,
						items: values.map(el => el._id),
						action: {
							type: "hook",
							code: event?.code,
							config: event?.config ?? {}
						}
					},
					() => {
						showInfoMessage(t("FORMS.RESOURCE.runningAction"));
					},
					() => {
						showErrorMessage(t("FORMS.RESOURCE.actionError"));
					}
				);
				break;
			}
		}
	};

	/**
	 * Websocket event handler
	 * Update the list with the new datas
	 * @param {object} datas - Datas to update
	 * @returns {void} - Nothing
	 */
	function updateResourceDatas(datas) {
		const action = datas?.action;
		const data = datas?.data;

		if (lod_.isNil(action) || lod_.isNil(data) || lod_.isEmpty(charts) || lod_.isNil(charts)) {
			return;
		}

		let list = charts[0];

		switch (action) {
			case "create": {
				// Reload the chart when a new item is created
				setReloadTable(!reloadTable);
				break;
			}
			case "update": {
				// Update the chart when an item is updated
				list.rows = (list.rows ?? []).map(row => {
					if (row._id === data._id) {
						return lod_.merge(row, data);
					}
					return row;
				});
				setCharts([list]);
				break;
			}
			default:
				break;
		}
	}

	/**
	 * Reset URL query filters
	 */
	const resetUrlQuery = () => {
		setFiltersURL({}); // Reset state
		window.history.replaceState({}, "", window.location.pathname); // Reset URL
		loadCharts({}); // Reload charts
	};

	/**
	 * Load charts when assistant changes or route changes
	 */
	useEffect(() => {
		const urlQuery = getUrlQuery();
		setFiltersURL(urlQuery);
		setChartsLoading(true);
		setResource(null);
		setSelectedRows([]);
		loadCharts(urlQuery);
	}, [profile.selectedAssistant.assistantID, route]);

	useEffect(() => {
		/**
		 * WS Event
		 */
		const UPDATE_RESOURCE_DATAS = `UPDATE_RESOURCE_DATAS_${resource?.code}`;

		if (!lod_.isEmpty(resource)) {
			socket.on(UPDATE_RESOURCE_DATAS, updateResourceDatas);
		}

		return () => {
			socket.off(UPDATE_RESOURCE_DATAS, updateResourceDatas);
		};
	}, [resource]);

	/**
	 * Get allowed event types for the resource
	 * @param {object} resource - Resource to get events from
	 * @returns {array} - Allowed event types
	 */
	const getAllowedEventTypes = resource => {
		return (resource?.events ?? []).filter(event => ALLOWED_ACTION_TYPE.includes(event.type));
	};

	/**
	 * Charts loader
	 */
	if (chartsLoading) {
		return (
			<DashboardLayout>
				<MDBox py={3}>
					<DashboardNavbar />
					<ChartsLoader darkMode={darkMode} />
				</MDBox>
			</DashboardLayout>
		);
	} else
		/**
		 * Main component
		 */
		return (
			<DashboardLayout>
				{!lod_.isEmpty(dictionary) && (
					<ImportDialog
						{...importDialog}
						dictionary={lod_.get(dictionary, route.form.routeDictionary)}
						handleClose={() => setImportDialog({ ...importDialog, open: false })}
						handleSave={handleImportCSV}
					/>
				)}
				<MDBox mb={3}>
					<DashboardNavbar
						filters={[
							<MDBox display="flex" justifyContent="space-between" alignItems="center">
								{/* First part */}
								{lod_.isEmpty(filtersURL) && (
									<MDBox display="flex" alignItems="center" flexDirection="row">
										{route.form.add !== false && (
											<MDButton
												style={{ height: "100%" }}
												variant="contained"
												color="info"
												onClick={actionEditEmptyHandle}
											>
												{i18n.t("SETTINGS.add")}
											</MDButton>
										)}
										{route.form.importCSV === true && (
											<label htmlFor="file">
												<input
													id="file"
													type="file"
													name="file"
													accept={[
														".xls",
														".xlsx",
														".xlsm",
														".xlsb",
														".xlt",
														".xltx",
														".xltm",
														".xlam",
														".ods",
														".csv"
													]}
													hidden
													disabled={lod_.isEmpty(dictionary)}
													onChange={handleImportFile}
												/>
												<Tooltip placement="top" title={t("FORMS.importFile")}>
													<IconButton
														color="dark"
														disabled={lod_.isEmpty(dictionary)}
														component="span"
													>
														<Icon>publish</Icon>
													</IconButton>
												</Tooltip>
											</label>
										)}
										{filtersComponents}
									</MDBox>
								)}
								{!lod_.isEmpty(filtersURL) && (
									<MDBox display="flex" alignItems="center" flexDirection="row">
										<MDButton
											style={{ height: "100%" }}
											variant="contained"
											color="info"
											onClick={resetUrlQuery}
										>
											<Icon>clear</Icon>&nbsp;Réinitialiser les filtres
										</MDButton>
									</MDBox>
								)}
								{/* Second part */}
								<MDBox display="flex" alignItems="center" flexDirection="row">
									{/* Fusion contact, specific to "contact" page */}
									<ActionFusionContact
										route={route}
										dictionary={dictionary}
										selectedRows={selectedRows}
										setSelectedRows={setSelectedRows}
										reloadTable={reloadTable}
										setReloadTable={setReloadTable}
									/>
									{/* Resource events */}
									<ResourceEventsMenu
										resource={resource}
										selectedRows={selectedRows}
										setSelectedRows={setSelectedRows}
										performAction={performActionHandle}
										loadCharts={loadCharts}
									/>
								</MDBox>
							</MDBox>
						]}
					/>
				</MDBox>

				{addNewItem && (!lod_.isEmpty(valuesForm) || empty) && (
					<FormDictionaryDialog
						open={addNewItem}
						route={route}
						handleCloseDialog={() => setAddNewItem(false)}
						handleSave={(values, unique, callback) => {
							if (empty) {
								// If empty, add item
								addItemHandle(values, unique, callback, valuesForm.rolesProfileUser);
							} else {
								// If not empty, update item
								updateItemHandle(values, unique, callback);
							}
						}}
						listAPIs={listAPIs}
						regexEmail={regexEmail}
						valuesDictionary={valuesForm}
						formBuildDictionary={formBuild}
						contextDictionary={contextDictionary}
						PIaccess={PI}
						isEmpty={empty}
						target={selectedTarget}
						selectedId={selectedId}
						routeDict={routeDict}
						flagAccount={flagAccount}
					/>
				)}
				{confirmDelete && (
					<Dialog open={confirmDelete} onClose={closeDeleteHandle}>
						<DialogTitle>{i18n.t("FORMS.LABELS.delete")}</DialogTitle>
						<DialogContent>
							{i18n.t("FORMS.LABELS.confirmDelete")}: {selectedItem.name}
						</DialogContent>
						<DialogActions>
							<MDButton autoFocus onClick={closeDeleteHandle} variant="outlined" color="dark">
								{i18n.t("FORMS.cancel")}
							</MDButton>
							<MDButton onClick={deleteItemHandle} color="dark" variant="contained" autoFocus>
								{i18n.t("FORMS.validate")}
							</MDButton>
						</DialogActions>
					</Dialog>
				)}

				{/*
				 * Interface controller
				 */}
				<InterfaceController
					ref={interfaceControllerRef}
					resource={resource}
					refreshChart={loadCharts}
				/>

				{/*
				 * Actions controller
				 */}
				<ActionsController
					ref={actionControllerRef}
					performActionHandle={performActionHandle}
					insertResource={insertResource}
					updateResource={updateResource}
					deleteResource={deleteResource}
					insertResourceEvent={insertResourceEvent}
					dictionary={dictionary}
					resource={resource}
				/>

				{/*
				 * Pagined table
				 */}
				{getChartsData()
					.filter(chart => chart.type === "paginedList")
					.map((chart, index) => {
						return (
							<MDBox>
								<DefaultDataTable
									key={index}
									compact
									noHeader
									noMargin
									form={route.form}
									dictionary={chart.dictionary}
									displayDictionaryName={resource?.format?.dictionary ?? null}
									checkbox
									selectedRows={selectedRows}
									handleSelection={(values, item, action, source) => {
										const visualizationAction = (resource?.events ?? []).find(
											event => event.type === "visualization"
										);
										if (
											lod_.isNil(visualizationAction) ||
											lod_.isNil(visualizationAction?.config?.action)
										) {
											// No visualization action, just set selected rows
											setSelectedRows(values);
										} else if (source === "checkbox") {
											// If source is checkbox, set selected rows
											setSelectedRows(values);
										} else {
											// Execute visualization action
											actionControllerRef.current?.startAction(visualizationAction, item);
										}
									}}
									isSelectedRow={row => {
										const existingRow = selectedRows.find(r => r._id === row._id);
										return Boolean(existingRow);
									}}
									id={chart.code}
									canSearch
									table={chart.data}
									display={chart.request.attributesDisplay}
									pagination={chart.pagination}
									list={chart}
									reloadTable={reloadTable}
									setReloadTable={setReloadTable}
									loadCharts={loadCharts}
									filters={{
										...getLocalStorageBackValues(
											profile.selectedAssistant.assistantID,
											route.route,
											filters
										),
										...filtersURL
									}}
									actions={[
										<IconButton
											handleclick={({ original }, e) => {
												setMenuValues(original);
												setMenuRef(e.currentTarget);
												e.preventDefault();
												e.stopPropagation();
											}}
										>
											<Icon fontSize="medium">more_vert</Icon>
										</IconButton>
									]}
								/>

								{/* Menu actions selection */}
								<Menu
									open={Boolean(menuRef)}
									anchorEl={menuRef}
									onClose={() => {
										setMenuRef(null);
									}}
								>
									{/* Options */}
									{(route.form.edit !== false || route.form.delete !== false) && (
										<>
											<MenuItem disabled style={{ opacity: 1 }}>
												<MDTypography variant="caption">{t("SETTINGS.actions")}</MDTypography>
											</MenuItem>
											{route.form.edit !== false && (
												<MenuItem
													onClick={() => {
														actionEditHandle(menuValues, chart.request.collection);
														setMenuRef(null);
													}}
												>
													<Icon fontSize="medium">edit</Icon>&nbsp;{i18n.t("SETTINGS.edit")}
												</MenuItem>
											)}
											{route.form.delete !== false && (
												<MenuItem
													onClick={() => {
														actionDeleteHandle(menuValues, chart.request.collection);
														setMenuRef(null);
													}}
												>
													<Icon fontSize="medium">delete</Icon>&nbsp;{i18n.t("SETTINGS.delete")}
												</MenuItem>
											)}
										</>
									)}
									{getAllowedEventTypes(resource).length > 0 && (
										<>
											{(route.form.edit !== false || route.form.delete !== false) && <Divider />}
											<MenuItem disabled style={{ opacity: 1 }}>
												<MDTypography variant="caption">{t("SETTINGS.actions")}</MDTypography>
											</MenuItem>
											{getAllowedEventTypes(resource).map((event, index) => {
												return (
													<MenuItem
														key={index}
														onClick={() => {
															if (
																actionControllerRef.current?.isSpecialAction(event.code) ||
																event.type === "visualization"
															) {
																actionControllerRef.current?.startAction(event, menuValues);
															} else {
																performActionHandle(event, [menuValues]);
															}
															setMenuRef(null);
														}}
													>
														{event.icon && (
															<>
																<Icon fontSize="medium">{event.icon}</Icon>&nbsp;
															</>
														)}
														{event.description}
													</MenuItem>
												);
											})}
										</>
									)}
								</Menu>
							</MDBox>
						);
					})}
			</DashboardLayout>
		);
}
